var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWorkOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elements",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sidebar-icons-V2",
    transform: "translate(-61.000000, -283.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_work_order",
    transform: "translate(61.000000, 283.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 4.000000)",
    fill: "#616674",
    className: "wo-icon-lines"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6875,1 L16.3125,1 C16.690625,1 17,1.45 17,2 L17,2 C17,2.55 16.690625,3 16.3125,3 L6.6875,3 C6.309375,3 6,2.55 6,2 L6,2 C6,1.45 6.309375,1 6.6875,1 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6875,8 L16.3125,8 C16.690625,8 17,7.55 17,7 L17,7 C17,6.45 16.690625,6 16.3125,6 L6.6875,6 C6.309375,6 6,6.45 6,7 L6,7 C6,7.55 6.309375,8 6.6875,8 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,13 L7,13 C7.55,13 8,12.55 8,12 L8,12 C8,11.45 7.55,11 7,11 L2,11 C1.45,11 1,11.45 1,12 L1,12 C1,12.55 1.45,13 2,13 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.2175,7.4175 C-0.0725,7.1275 -0.0725,6.6475 0.2175,6.3575 L0.2175,6.3575 C0.5075,6.0675 0.9875,6.0675 1.2775,6.3575 L2.0975,7.1775 L4.0575,5.2175 C4.3475,4.9275 4.8275,4.9275 5.1175,5.2175 L5.1175,5.2175 C5.4075,5.5075 5.4075,5.9875 5.1175,6.2775 L2.4675,8.9275 C2.2775,9.1175 1.9575,9.1275 1.7675,8.9275 L0.2175,7.4175 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.2775,0.225 L2.1575,1.105 L3.0375,0.225 C3.3275,-0.065 3.8075,-0.065 4.0975,0.225 L4.0975,0.225 C4.3875,0.515 4.3875,0.995 4.0975,1.285 L3.2175,2.165 L4.0975,3.045 C4.3875,3.335 4.3875,3.815 4.0975,4.105 L4.0975,4.105 C3.8075,4.395 3.3275,4.395 3.0375,4.105 L2.1575,3.225 L1.2775,4.105 C0.9875,4.395 0.5075,4.395 0.2175,4.105 L0.2175,4.105 C-0.0725,3.815 -0.0725,3.335 0.2175,3.045 L1.0975,2.165 L0.2175,1.285 C-0.0725,0.995 -0.0725,0.515 0.2175,0.225 L0.2175,0.225 C0.5075,-0.075 0.9775,-0.075 1.2775,0.225 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    className: "wo-icon-spare",
    d: "M22.4285936,18.99 C22.4285936,18.77 22.3985936,18.57 22.3685936,18.36 L23.2085936,17.63 C23.3885936,17.47 23.4285936,17.21 23.3085936,17 L22.7185936,15.98 C22.5985936,15.77 22.3485936,15.68 22.1285936,15.76 L21.0685936,16.12 C20.7485936,15.85 20.3885936,15.64 19.9885936,15.49 L19.7685936,14.4 C19.7185936,14.17 19.5185936,14 19.2785936,14 L18.0985936,14 C17.8585936,14 17.6585936,14.17 17.6085936,14.4 L17.3885936,15.49 C16.9885936,15.64 16.6285936,15.85 16.3085936,16.12 L15.2485936,15.76 C15.0185936,15.68 14.7785936,15.78 14.6585936,15.98 L14.0685936,17 C13.9485936,17.21 13.9885936,17.47 14.1685936,17.63 L15.0085936,18.36 C14.9785936,18.57 14.9485936,18.77 14.9485936,18.99 C14.9485936,19.21 14.9785936,19.41 15.0085936,19.62 L14.1685936,20.35 C13.9885936,20.51 13.9485936,20.77 14.0685936,20.98 L14.6585936,22 C14.7785936,22.21 15.0285936,22.3 15.2485936,22.22 L16.3085936,21.86 C16.6285936,22.13 16.9885936,22.34 17.3885936,22.49 L17.6085936,23.58 C17.6585936,23.81 17.8585936,23.98 18.0985936,23.98 L19.2785936,23.98 C19.5185936,23.98 19.7185936,23.81 19.7685936,23.58 L19.9885936,22.49 C20.3885936,22.34 20.7485936,22.13 21.0685936,21.86 L22.1285936,22.22 C22.3585936,22.3 22.5985936,22.2 22.7185936,22 L23.3085936,20.98 C23.4285936,20.77 23.3885936,20.51 23.2085936,20.35 L22.3685936,19.62 C22.3985936,19.41 22.4285936,19.21 22.4285936,18.99 Z M18.6785936,20.99 C17.5785936,20.99 16.6785936,20.09 16.6785936,18.99 C16.6785936,17.89 17.5785936,16.99 18.6785936,16.99 C19.7785936,16.99 20.6785936,17.89 20.6785936,18.99 C20.6785936,20.09 19.7785936,20.99 18.6785936,20.99 Z",
    id: "Shape",
    fill: "#616674"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWorkOrder);
export default __webpack_public_path__ + "static/media/ic_work_order.2a0e98f7ded831b6aa40a7bfaf4e50a0.svg";
export { ForwardRef as ReactComponent };